import { invalidateShortcutsByFavorite, invalidateUsersListChangelistTable } from './Invalidation'
import getStorage from '../../Common/Services/Storage'
import defaults from './Defaults'

const storageService = getStorage()

const Config = {
  environment: process.env.REACT_APP_ENVIRONMENT,
  frec: {
    enabled: storageService.get('configFrecEnabled', defaults.frec.enabled),
    defaultExpandedMenu: storageService.get('configFrecDefaultExpandedMenu', defaults.frec.defaultExpandedMenu),
    enableFixByteSizeButton: storageService.get('configEnableFixByteSizeButton', defaults.frec.enableFixByteSizeButton),
    showSyncAliasGroupsButton: storageService.get(
      'configShowSyncAliasGroupsButton',
      defaults.frec.showSyncAliasGroupsButton,
    ),
    openParsedFilesDetailsInNewWindow: storageService.get(
      'configOpenParsedFilesDetailsInNewWindow',
      defaults.frec.openParsedFilesDetailsInNewWindow,
    ),
  },
  testCell: {
    enabled: process.env.NODE_ENV === 'development'
        ? storageService.get('configTestCellEnabled', defaults.testCell.enabled)
        : false,
  },
  externalApi: {
    enabled: storageService.get('configExternalApiEnabled', defaults.externalApi.enabled),
  },
  ftao: {
    enabled: storageService.get('configFtaoEnabled', defaults.ftao.enabled),
    enableDashboardExport: storageService.get('configFtaoEnableDashboardExport', defaults.ftao.enableDashboardExport),
    enableSuggestions: storageService.get('configFtaoEnableSuggestions', defaults.ftao.enableSuggestions),
    enablePowerbi: storageService.get('configFtaoEnablePowerbi', defaults.ftao.enablePowerbi),
  },
  digitalTwin: {
    enabled: storageService.get('configDigitalTwinEnabled', defaults.digitalTwin.enabled),
    enableMonitoring: storageService.get('configDigitalTwinEnableMonitoring', defaults.digitalTwin.enableMonitoring),
  },
  ui: {
    enableAdvancedShortcuts: storageService.get('configEnableAdvancedShortcuts', defaults.ui.enableAdvancedShortcuts),
    enableChangelistTableColumnsResizing: storageService.get(
      'configEnableChangelistTableColumnsResizing',
      defaults.ui.enableChangelistTableColumnsResizing,
    ),
    enableChangelistTableGoToTop: storageService.get(
      'configEnableChangelistTableGoToTop',
      defaults.ui.enableChangelistTableGoToTop,
    ),
    enableChangelistPaginationOnTop: storageService.get(
      'configEnableChangelistPaginationOnTop',
      defaults.ui.enableChangelistPaginationOnTop,
    ),
    enableChangelistTableClickOnRowSelect: storageService.get(
      'configEnableChangelistTableClickOnRowSelect',
      defaults.ui.enableChangelistTableClickOnRowSelect,
    ),
    enableTour: storageService.get('configEnableTour', defaults.ui.enableTour),
    enableAssistant: storageService.get('configEnableAssistant', defaults.ui.enableAssistant),
    defaultOpenSidebar: storageService.get('configDefaultOpenSidebar', defaults.ui.defaultOpenSidebar),
    enableDeviceFamily: defaults.ui.enableDeviceFamily,
    gravatarEmail: storageService.get('configGravatarEmail', defaults.ui.gravatarEmail),
    defaultExpandedMainMenu: storageService.get('configDefaultExpandedMainMenu', defaults.ui.defaultExpandedMainMenu),
    defaultExpandedRightMenu: storageService.get(
      'configDefaultExpandedRightMenu',
      defaults.ui.defaultExpandedRightMenu,
    ),
    reportsGridColumns: storageService.get('configReportsGridColumns', defaults.ui.reportsGridColumns),
    reportsGridRowHeight: storageService.get('configReportsGridRowHeight', defaults.ui.reportsGridRowHeight),
    reportsItemHeaderHeight: defaults.ui.reportsItemHeaderHeight,
    reportsItemMargin: storageService.get('configReportsItemMargin', defaults.ui.reportsItemMargin),
    reportsEnableExport: storageService.get('configReportsEnableExport', defaults.ui.reportsEnableExport),
    enableStickyNavbar: storageService.get('configEnableStickyNavbar', defaults.ui.enableStickyNavbar),
    enableStickyFooter: storageService.get('configEnableStickyFooter', defaults.ui.enableStickyFooter),
  },
  charts: {
    highchartsEnableExport: storageService.get('configHighchartsEnableExport', defaults.charts.highchartsEnableExport),
    highchartsExportWidth: storageService.get('configHighchartsExportWidth', defaults.charts.highchartsExportWidth),
    highchartsExportHeight: storageService.get('configHighchartsExportHeight', defaults.charts.highchartsExportHeight),
    // colorAxisStopsLightBlue: storageService.get('configColorAxisStopsLight', [
    //   { perc: 0, color: '#fff' },
    //   { perc: 0.00000000001, color: '#DEE5F2' },
    //   { perc: 0.08, color: '#CED8EB' },
    //   { perc: 0.16, color: '#BDCBE5' },
    //   { perc: 0.24, color: '#ADBEDE' },
    //   { perc: 0.32, color: '#9CB1D8' },
    //   { perc: 0.4, color: '#8BA4D1' },
    //   { perc: 0.48, color: '#7B97CA' },
    //   { perc: 0.56, color: '#6A8AC4' },
    //   { perc: 0.64, color: '#5A7DBD' },
    //   { perc: 0.72, color: '#4A70B7' },
    //   { perc: 0.8, color: '#3963B0' },
    //   { perc: 0.88, color: '#2856AA' },
    //   { perc: 1, color: '#1849A3' },
    // ]),
    colorAxisStopsLight: storageService.get('configColorAxisStopsLight', defaults.charts.colorAxisStopsLight),
    colorAxisStopsDark: storageService.get('configColorAxisStopsDark', defaults.charts.colorAxisStopsDark),
    palette: storageService.get('configHighchartsPalette', defaults.charts.palette),
  },
  maps: {
    mapId: process.env.REACT_APP_GOOGLE_MAP_ID,
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    defaultMapType: storageService.get('configDefaultMapType', defaults.maps.defaultMapType),
    defaultMapTiles: storageService.get('configDefaultMapTiles', defaults.maps.defaultTiles),
    defaultLayer: storageService.get('configDefaultMapLayer', defaults.maps.defaultLayer),
    polylineHeatmapStops: storageService.get('configPolylineHeatmapStops', defaults.maps.polylineHeatmapStops),
  },
  data: {
    vTableSignalVariabilityLimit: storageService.get(
      'configVTableSignalVariabilityLimit',
      defaults.data.vTableSignalVariabilityLimit,
    ),
    dataAnalyticsMaxSignalValuesInterval: storageService.get(
      'configDataAnalyticsMaxSignalValuesInterval',
      defaults.data.dataAnalyticsMaxSignalValuesInterval,
    ),
    modelDashboardMaxSignalValuesInterval: storageService.get(
      'configModelDashboardMaxSignalValuesInterval',
      defaults.data.modelDashboardMaxSignalValuesInterval,
    ),
    modelDashboardLiveDataSignalInterval: storageService.get(
      'configModelDashboardLiveDataSignalInterval',
      defaults.data.modelDashboardLiveDataSignalInterval,
    ),
    masterChartSamples: storageService.get('configMasterChartSamples', defaults.data.masterChartSamples),
    masterChartMaxChunkDuration: storageService.get(
      'configMasterChartMaxChunkDuration',
      defaults.data.masterChartMaxChunkDuration,
    ),
    exportRowsLimit: storageService.get('configExportRowsLimit', defaults.data.exportRowsLimit),
    // dataAnalyticsMaxSignalValuesInterval: 60 * 2,
  },
  reports: {
    signalPlotChartsSamples: storageService.get(
      'configReportSignalPlotChartSamples',
      defaults.reports.signalPlotChartsSamples,
    ),
    gpsTrackingSamples: storageService.get('configReportGpsTrackingSamples', defaults.reports.gpsTrackingSamples),
    enableLocalReports: storageService.get('configEnableLocalReports', defaults.reports.enableLocalReports),
  },
  logger: {
    level: storageService.get('configLogLevel', defaults.logger.level), // DEBUG, INFO, WARNING, ERROR
  },
  debounceTime: storageService.get('configInputsDebounceTime', defaults.debounceTime),
  enableSaveFilters: storageService.get('configEnableSaveFilters', defaults.enableSaveFilters),
  enableSavePagination: storageService.get('configEnableSavePagination', defaults.enableSavePagination),
  enableReadOnlyDetails: storageService.get('configEnableReacOnlyDetails', defaults.enableReadOnlyDetails),
  apiBasePath: process.env.REACT_APP_API_BASE_PATH,
  validation: {
    configurationNameRexp: '^[A-Za-z0-9\\-_]*$',
    vehicleNameRexp: "^[^:/?#\\[\\]@!$&'()*+,;=]*$",
    deviceNameRexp: "^[^:/?#\\[\\]@!$&'()*+,;=]*$",
    missionProfileElementRexp: '^[A-Za-z0-9\\-_. /\\[\\]]*$',
  },
  urls: {
    frec: {
      main: '/frec',
      home: '/frec/dashboard',
      users: '/frec/users',
      vehicles: {
        list: '/frec/vehicles',
        applicationFiles: {
          main: '/frec/vehicles/data/applicationfiles',
        },
        parsedFiles: {
          main: '/frec/vehicles/data/parsedfiles',
          detail: '/frec/vehicles/data/parsedfiles/:id',
          detailTest: '/frec/vehicles/data/parsedfiles/test/:id',
          deltaDetail: '/frec/vehicles/data/parsedfiles/delta/:id1/:id2/:type',
        },
      },
      items: {
        list: '/frec/items',
      },
      tables: {
        list: '/frec/tables',
      },
      signals: {
        list: '/frec/signals',
      },
      specifications: {
        list: '/frec/specifications',
        create: '/frec/specifications/create',
        update: '/frec/specifications/update/:id',
      },
    },
    ftao: {
      main: '/ftao',
      rgPlan: '/ftao/rgplan/:id',
      rgPlanDashboard: '/ftao/rgplan/:id/dashboard',
      rgPlanPowerBi: '/ftao/rgplan/:id/powerbi',
      rgPlanFingerprintDashboard: '/ftao/rgplan/:id/fingerprint/dashboard',
      rgPlanTargetDashboard: '/ftao/rgplan/:id/target/dashboard',
      rgPlanVehicle: '/ftao/rgplan/:id/vehicle/:vehicleId',
    },
    digitalTwin: {
      main: '/digitaltwin',
      models: {
        list: '/digitaltwin/models',
      },
      instances: {
        list: '/digitaltwin/instances',
      },
    },
    home: '/dashboard',
    login: '/',
    support: '/support',
    vehicleComponents: {
      list: '/vehicle-components',
      rawData: '/vehicle-components/rawdata',
      canLogger: {
        main: '/vehicle-components/canlogger',
        detail: '/vehicle-components/canlogger/:id',
      },
      signalLogger: {
        main: '/vehicle-components/signallogger',
        detail: '/vehicle-components/signallogger/:id',
      },
      rtm: '/vehicle-components/rtmfiles',
      rtmTrips: {
        main: '/vehicle-components/rtmtrips',
        detail: '/vehicle-components/rtmtrips/:id',
        detailPlus: '/vehicle-components/rtmtrips/plus/:id',
      },
      rtmEvents: {
        main: '/vehicle-components/rtmevents',
        detail: '/vehicle-components/rtmevents/:id',
      },
      rtmDtcs: {
        main: '/vehicle-components/rtmdtcs',
        detail: '/vehicle-components/rtmdtcs/:id',
      },
      miniVpr: '/vehicle-components/minivpr',
      missionProfile: {
        main: '/vehicle-components/missionprofile',
        detail: '/vehicle-components/missionprofile/:id',
        aggregationDetail: '/vehicle-components/missionprofile/aggregation/:id',
      },
      vehicleDiagnostic: '/vehicle-components/vehiclediagnostic',
      infoReader: '/vehicle-components/inforeader',
      externalCanLogger: {
        main: '/vehicle-components/external/canlogger',
        detail: '/vehicle-components/external/canlogger/:id',
      },
      externalTdms: {
        main: '/vehicle-components/external/tdms',
        detail: '/vehicle-components/external/tdms/:id',
      },
    },
    vehicles: {
      list: '/vehicles',
      rawData: '/vehicles/rawdata',
      documents: '/vehicles/documents',
      images: {
        main: '/vehicles/images',
        detail: '/vehicles/images/:id',
        supervisely: '/vehicles/images/:id/supervisely',
        jobs: '/vehicles/images/jobs',
        datasets: '/vehicles/images/datasets',
        datasetDetail: '/vehicles/images/datasets/:datasetId',
      },
      models: {
        main: '/vehicles/:vehicleId/models',
        detail: '/vehicles/:vehicleId/models/:modelId/:min/:max?',
      },
      canLogger: {
        main: '/vehicles/canlogger',
        detail: '/vehicles/canlogger/:id',
      },
      signalLogger: {
        main: '/vehicles/signallogger',
        detail: '/vehicles/signallogger/:id',
      },
      rtm: '/vehicles/rtmfiles',
      rtmTrips: {
        main: '/vehicles/rtmtrips',
        detail: '/vehicles/rtmtrips/:id',
        detailPlus: '/vehicles/rtmtrips/plus/:id',
      },
      rtmEvents: {
        main: '/vehicles/rtmevents',
        detail: '/vehicles/rtmevents/:id',
      },
      rtmDtcs: {
        main: '/vehicles/rtmdtcs',
        detail: '/vehicles/rtmdtcs/:id',
      },
      miniVpr: '/vehicles/minivpr',
      missionProfile: {
        main: '/vehicles/missionprofile',
        detail: '/vehicles/missionprofile/:id',
        aggregationDetail: '/vehicles/missionprofile/aggregation/:id',
      },
      vehicleDiagnostic: '/vehicles/vehiclediagnostic',
      infoReader: '/vehicles/inforeader',
      externalCanLogger: {
        main: '/vehicles/external/canlogger',
        detail: '/vehicles/external/canlogger/:id',
      },
      externalTdms: {
        main: '/vehicles/external/tdms',
        detail: '/vehicles/external/tdms/:id',
      },
    },
    devices: {
      list: '/devices',
      rawData: '/devices/rawdata',
      documents: '/devices/documents',
      images: {
        main: '/devices/images',
        detail: '/devices/images/:id',
        supervisely: '/devices/images/:id/supervisely',
        jobs: '/devices/images/jobs',
        datasets: '/devices/images/datasets',
        datasetDetail: '/devices/images/datasets/:datasetId',
      },
      models: {
        main: '/devices/:deviceId/models',
        detail: '/devices/:deviceId/models/:modelId/:min/:max?',
      },
      canLogger: {
        main: '/devices/canlogger',
        detail: '/devices/canlogger/:id',
      },
      signalLogger: {
        main: '/devices/signallogger',
        detail: '/devices/signallogger/:id',
      },
      rtm: '/devices/rtmfiles',
      rtmTrips: {
        main: '/devices/rtmtrips',
        detail: '/devices/rtmtrips/:id',
        detailPlus: '/devices/rtmtrips/plus/:id',
      },
      rtmEvents: {
        main: '/devices/rtmevents',
        detail: '/devices/rtmevents/:id',
      },
      rtmDtcs: {
        main: '/devices/rtmdtcs',
        detail: '/devices/rtmdtcs/:id',
      },
      miniVpr: '/devices/minivpr',
      missionProfile: {
        main: '/devices/missionprofile',
        detail: '/devices/missionprofile/:id',
        aggregationDetail: '/devices/missionprofile/aggregation/:id',
      },
      vehicleDiagnostic: '/devices/vehiclediagnostic',
      infoReader: '/devices/inforeader',
      externalCanLogger: {
        main: '/devices/external/canlogger',
        detail: '/devices/external/canlogger/:id',
      },
      externalTdms: {
        main: '/devices/external/tdms',
        detail: '/devices/external/tdms/:id',
      },
    },
    testRevisions: {
      list: '/testrevisions',
      create: '/testrevisions/create',
      edit: '/testrevisions/edit/:id?',
      rawData: '/testrevisions/rawdata',
      canLogger: {
        main: '/testrevisions/canlogger',
        detail: '/testrevisions/canlogger/:id',
      },
      signalLogger: {
        main: '/testrevisions/signallogger',
        detail: '/testrevisions/signallogger/:id',
      },
      rtm: '/testrevisions/rtmfiles',
      rtmTrips: {
        main: '/testrevisions/rtmtrips',
        detail: '/testrevisions/rtmtrips/:id',
        detailPlus: '/testrevisions/rtmtrips/plus/:id',
      },
      rtmEvents: {
        main: '/testrevisions/rtmevents',
        detail: '/testrevisions/rtmevents/:id',
      },
      rtmDtcs: {
        main: '/testrevisions/rtmdtcs',
        detail: '/testrevisions/rtmdtcs/:id',
      },
      miniVpr: '/testrevisions/minivpr',
      missionProfile: {
        main: '/testrevisions/missionprofile',
        detail: '/testrevisions/missionprofile/:id',
        aggregationDetail: '/testrevisions/missionprofile/aggregation/:id',
      },
      vehicleDiagnostic: '/testrevisions/vehiclediagnostic',
      infoReader: '/testrevisions/inforeader',
      externalCanLogger: {
        main: '/testrevisions/external/canlogger',
        detail: '/testrevisions/external/canlogger/:id',
      },
      externalTdms: {
        main: '/testrevisions/external/tdms',
        detail: '/testrevisions/external/tdms/:id',
      },
    },
    testCells: {
      list: '/testcells',
      rawData: '/testcells/rawdata',
      canLogger: {
        main: '/testcells/canlogger',
        detail: '/testcells/canlogger/:id',
      },
      signalLogger: {
        main: '/testcells/signallogger',
        detail: '/testcells/signallogger/:id',
      },
      rtm: '/testcells/rtmfiles',
      rtmTrips: {
        main: '/testcells/rtmtrips',
        detail: '/testcells/rtmtrips/:id',
        detailPlus: '/testcells/rtmtrips/plus/:id',
      },
      rtmEvents: {
        main: '/testcells/rtmevents',
        detail: '/testcells/rtmevents/:id',
      },
      rtmDtcs: {
        main: '/testcells/rtmdtcs',
        detail: '/testcells/rtmdtcs/:id',
      },
      miniVpr: '/testcells/minivpr',
      missionProfile: {
        main: '/testcells/missionprofile',
        detail: '/testcells/missionprofile/:id',
        aggregationDetail: '/testcells/missionprofile/aggregation/:id',
      },
      vehicleDiagnostic: '/testcells/vehiclediagnostic',
      infoReader: '/testcells/inforeader',
      externalCanLogger: {
        main: '/testcells/external/canlogger',
        detail: '/testcells/external/canlogger/:id',
      },
      externalTdms: {
        main: '/testcells/external/tdms',
        detail: '/testcells/external/tdms/:id',
      },
    },
    archive: {
      base: '/archive',
      deviceImages: '/archive/images',
    },
    users: '/users',
    externalApi: '/users/external-api',
    resources: '/resources',
    configurator: '/configurator',
    configuration: {
      canSettings: {
        main: '/configurator/:id/cansettings',
      },
      hardwareSettings: {
        main: '/configurator/:id/hwsettings',
      },
      a2lSignalConfigurations: {
        main: '/configurator/:id/a2lsignalconfigurations',
      },
      signalAlias: {
        main: '/configurator/:id/signalaliases',
      },
      triggers: {
        main: '/configurator/:id/triggers',
        detail: '/configurator/:id/triggers/detail/:triggerId?',
      },
      signalLogger: {
        main: '/configurator/:id/loggers/signal',
        detail: '/configurator/:id/loggers/signal/update/:loggerId?',
        info: '/configurator/:id/loggers/signal/update/:loggerId?/info',
      },
      canLogger: {
        main: '/configurator/:id/loggers/can',
        detail: '/configurator/:id/loggers/can/update/:loggerId?',
        info: '/configurator/:id/loggers/can/update/:loggerId?/info',
      },
      rtm: {
        main: '/configurator/:id/rtm',
        events: '/configurator/:id/rtm/events',
        signalLoggers: {
          main: '/configurator/:id/rtm/signal',
          detail: '/configurator/:id/rtm/signal/update/:loggerId?',
        },
        canLoggers: {
          main: '/configurator/:id/rtm/can',
          detail: '/configurator/:id/rtm/can/update/:loggerId?',
        },
      },
      missionProfile: {
        main: '/configurator/:id/missionprofile',
        accumulations: '/configurator/:id/missionprofile/accumulations',
        items: '/configurator/:id/missionprofile/items',
      },
      miniVpr: {
        main: '/configurator/:id/minivpr',
      },
      dm1: {
        main: '/configurator/:id/dm1',
      },
      infoReader: {
        main: '/configurator/:id/inforeader',
      },
      insights: {
        main: '/configurator/:id/insights',
        create: '/configurator/:id/insights/create/:insightTypeId',
        detail: '/configurator/:id/insights/update/:insightId?',
      },
      blueTag: {
        main: '/configurator/:id/bluetag',
      },
      digitalTwin: {
        main: '/configurator/:id/digitaltwin',
      },
    },
    dataAnalytics: {
      main: '/data-analytics',
      create: '/data-analytics/create',
      detail: '/data-analytics/:id',
      dashboard: '/data-analytics/:id/:eventId',
      multiEventdashboard: '/data-analytics/:id/multi',
    },
    reports: {
      main: '/reports',
      detail: '/reports/:reportId',
      create: '/reports/create',
      update: '/reports/update/:reportId',
      localMain: '/reports/local',
      localDetail: '/reports/local/:reportId',
    },
    blueTag: {
      main: '/bluetag',
    },
    serverError: '/500/:error',
    forbidden: '/403/:error',
    pageNotFound: '/404',
    maintenance: '/maintenance',
  },
  localStorageInvalidation: {
    // 'data-analytics-queries_CHANGELIST_TABLE_SETTINGS': invalidateDataAnalyticsChangelistTable,
    resources_CHANGELIST_TABLE_SETTINGS: 1651653216215,
    vehicles_CHANGELIST_TABLE_SETTINGS: 1671442721804,
    devices_CHANGELIST_TABLE_SETTINGS: 1668587409003,
    'frec-specification-items_CHANGELIST_TABLE_SETTINGS': 1688745719420,
    'raw-data-files_CHANGELIST_TABLE_SETTINGS': 1668587409003,
    'info-reader-files_CHANGELIST_TABLE_SETTINGS': 1655131281178,
    'vehicle-diagnostic-files_CHANGELIST_TABLE_SETTINGS': 1655131281178,
    'mission-profile-sessions_CHANGELIST_TABLE_SETTINGS': 1655131281178,
    'mini-vpr-files_CHANGELIST_TABLE_SETTINGS': 1655131281178,
    'rtm-dtcs_CHANGELIST_TABLE_SETTINGS': 1655131281178,
    'rtm-events_CHANGELIST_TABLE_SETTINGS': 1655131281178,
    'rtm-trips_CHANGELIST_TABLE_SETTINGS': 1655131281178,
    'can-logger-files_CHANGELIST_TABLE_SETTINGS': 1670419553774,
    'signal-logger-files_CHANGELIST_TABLE_SETTINGS': 1670419553774,
    'tdms-files_CHANGELIST_TABLE_SETTINGS': 1670419553774,

    // Signal alias implementation (TODO: update the invalidation timestamp when releasing to prod)
    'signals-selector_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'dt-signals-selector_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'mp-limits-signals-selector_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'mp-accumulations_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'mp-limits_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'info-reader-signals-selector_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'config-signals-selector_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'default-ecu-signals-selector_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'trigger-node-signals-selector_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'signallogger-configuration-signals_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'configured-signals-selector_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'minivpr-configuration-signals_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'digital-tween-signals-input_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'digital-tween-signals-output_CHANGELIST_TABLE_SETTINGS': 1785394627011,
    'digital-tween-signals-benchmark_CHANGELIST_TABLE_SETTINGS': 1785394627011,

    'frec-specification-items': 1687879913350,
    'frec-specifications': 1688371988602,
    'image-bundles': 1750069398148,
    'dt-models': 1751452440420,
    deviceImages: 1769417889831,
    'search-shortcut-devices': invalidateShortcutsByFavorite,
    'search-shortcut-vehicles': invalidateShortcutsByFavorite,
    users_CHANGELIST_TABLE_SETTINGS: invalidateUsersListChangelistTable,
  },
}

export default Config
